<template>
  <div class="container-fluid init"> 
    <section id="proyecto-ahdeco-web" class="my-5">
      <div class="row">
        <!-- Col Izquierda: Galerías -->
        <div class="col-lg-2 col-12 d-flex flex-column align-items-center order-lg-1 order-3 mt-3 mt-lg-0">
          <div class="d-flex flex-column align-items-center justify-content-center text-center">
            <h4 class="mb-4">Galería de proyecto</h4>
            <PhotoGalleryModal :images="sitioweb" buttonLabel="Catálogo Cliente" />
             <br>
             <PhotoGalleryModal :images="admin"  buttonLabel="Administrador"/>
             <br>
            <PhotoGalleryModal :images="backend"  buttonLabel="Backend"/>
          </div>
        </div>

        <!-- Col Centro: Article NUEVO (reemplaza el anterior) -->
        <div class="col-12 col-lg-8 order-2 order-lg-2">
          <article class="card border-0 shadow-sm rounded-2">
            <div class="card-body p-4 p-lg-5">
              <div class="text-center mb-4">
                <!-- <span class="badge rounded-pill text-bg-light border me-2">Caso de estudio</span> -->
                <span class="badge rounded-pill text-bg-primary">E-commerce Catalogo</span>
              </div>

              <h1 class="h3 mb-3 display-6 text-center">
                Catálogo Digital de Productos con Vue.js + Django REST + PostgreSQL
              </h1>

              <p class="lead text-center mb-4">
                Gestión integral de inventario, precios, stock y descripciones enriquecidas; 
                interfaz responsive para clientes, panel administrativo completo y asistente de ventas en WhatsApp con IA.
              </p>
              <img src="img/proyectos/ecommerce/paginaweb/1.png" alt="Proyecto AHDECO" class="img-fluid mb-3 rounded-1 shadow-sm">

              <div class="row g-3 mb-4">
                <div class="col-12 col-md-6">
                  <div class="p-3 rounded-2 border bg-light">
                    <strong>Frontend (Vue.js)</strong>
                    <p class="mb-0 small">
                      SPA con componentes reutilizables, rutas protegidas, formularios validados, 
                      editor de texto enriquecido para descripciones y carga de imágenes.
                    </p>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="p-3 rounded-2 border bg-light">
                    <strong>API (Django REST Framework)</strong>
                    <p class="mb-0 small">
                      Endpoints JWT para autenticación y CRUD seguro de productos, categorías, variantes y stock.
                    </p>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="p-3 rounded-2 border bg-light">
                    <strong>Base de datos (PostgreSQL)</strong>
                    <p class="mb-0 small">
                      Esquema normalizado, índices para búsquedas rápidas y consultas seguras con paginación.
                    </p>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="p-3 rounded-2 border bg-light">
                    <strong>Automatización (n8n + WhatsApp IA)</strong>
                    <p class="mb-0 small">
                      Agente conectado al catálogo para consultas de disponibilidad, precios y órdenes desde WhatsApp.
                    </p>
                  </div>
                </div>
              </div>

              <hr class="my-4">

              <h2 class="h5">Características clave</h2>
              <ul class="mb-4">
                <li>Autenticación y autorización basadas en roles (admin, editor, ventas).</li>
                <li>Gestión de inventario con control de stock y variantes (tallas/colores).</li>
                <li>Editor enriquecido para descripciones, imágenes y especificaciones técnicas.</li>
                <li>Catálogo público responsive con filtros, búsqueda y paginación.</li>
                <li>Integración a WhatsApp (n8n) con respuestas guiadas por IA para consulta y compra.</li>
                <li>Buenas prácticas de rendimiento: lazy loading, code splitting, cache-control.</li>
                <li>Despliegue productivo en Linux + Nginx y versionamiento con Git.</li>
              </ul>

              <div class="alert alert-secondary d-flex align-items-start" role="alert">
                <i class="fa-solid fa-shield-halved me-2 mt-1"></i>
                <div>
                  <strong>Seguridad:</strong> Acceso a creación/edición de productos sólo para usuarios autenticados. 
                  La API valida tokens y permisos en cada petición.
                </div>
              </div>

              <div class="d-flex flex-wrap gap-2 mt-4">
                <span class="badge text-bg-dark">Vue 3</span>
                <span class="badge text-bg-dark">Django REST Framework</span>
                <span class="badge text-bg-dark">PostgreSQL</span>
                <span class="badge text-bg-dark">JWT Auth</span>
                <span class="badge text-bg-dark">n8n</span>
                <span class="badge text-bg-dark">WhatsApp Business API</span>
              </div>
            </div>
          </article>
        </div>

        <!-- Col Derecha: Botón -->
        <div class="col-12 col-lg-2 order-1 order-lg-3">
          <a class="btn btn-light" href="https://axum.hn/" target="_blank">
            Ir a Sitio <i class="fa-solid fa-diamond-turn-right"></i>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PhotoGalleryModal from '../../PhotoGalleryModal.vue'

export default {
  name: 'ahdecoStatic',
  components: {
    PhotoGalleryModal
  },
  data() {
    return {
      sitioweb: [],
      admin: [],
      backend: [],
    }
  },
  beforeMount() {

    for (let i = 1; i <= 7; i++) {
      this.sitioweb.push(`img/proyectos/ecommerce/paginaweb/${i}.png`);
    }

    // admin: 1 al 7 (corrige doble slash)
    for (let i = 1; i <= 7; i++) {
      this.admin.push(`img/proyectos/ecommerce/admin/${i}.png`);
    }

    // backend: 1 (ajustable si agregas más capturas)
    for (let i = 1; i <= 1; i++) {
      this.backend.push(`img/proyectos/ecommerce/backend/${i}.png`);
    }
  },
}
</script>

<style scoped>
.init {
  margin-top: 150px;
}
.tec {
  font-size: 0.8rem;
}
</style>
